var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4815 0C8.2695 0 0 8.288 0 18.5C0 28.712 8.2695 37 18.4815 37C28.712 37 37 28.712 37 18.5C37 8.288 28.712 0 18.4815 0ZM18.5 33.3C10.323 33.3 3.7 26.677 3.7 18.5C3.7 10.323 10.323 3.7 18.5 3.7C26.677 3.7 33.3 10.323 33.3 18.5C33.3 26.677 26.677 33.3 18.5 33.3ZM24.975 16.65C26.5105 16.65 27.75 15.4105 27.75 13.875C27.75 12.3395 26.5105 11.1 24.975 11.1C23.4395 11.1 22.2 12.3395 22.2 13.875C22.2 15.4105 23.4395 16.65 24.975 16.65ZM12.025 16.65C13.5605 16.65 14.8 15.4105 14.8 13.875C14.8 12.3395 13.5605 11.1 12.025 11.1C10.4895 11.1 9.25 12.3395 9.25 13.875C9.25 15.4105 10.4895 16.65 12.025 16.65ZM18.5 28.675C22.8105 28.675 26.4735 25.974 27.9535 22.2H9.0465C10.5265 25.974 14.1895 28.675 18.5 28.675Z",
    fill: "#ED553B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon3);
export default __webpack_public_path__ + "static/media/quoteIcon3.11c0d139be189d7d09cee4b88e9d2d33.svg";
export { ForwardRef as ReactComponent };